import { createFileRoute } from "@tanstack/react-router";
import { CountriesPage } from "@/components/registries/countries-page.js";

export const Route = createFileRoute("/_authenticated/configuration/registries/countries")({
  component: CountriesPage,
});
